<template>
  <div class="lottery">
    <div class="main-title">使用帮助/互动功能/抽奖</div>
    <h1 class="page-title">抽奖</h1>
    <h4 class="content-text">（1）签到抽奖，用户扫码进入奖池后，每轮随机抽取幸运用户获得相应奖品。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-lottery1_17682886572883ba880.webp"
      alt="酒吧大屏互动幸运抽奖"
      class="example-image"
    />
    <h4 class="content-text center">（3D抽奖）</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-lottery3_17682886572883643e7.webp"
      alt="酒吧大屏互动抽奖"
      class="example-image"
    />
    <h4 class="content-text center">（巨幕抽奖）</h4>
    <h4 class="content-text">2、需要提前在后台设置好名单，数字或文字，然后随机抽取幸运用户获得相应奖品。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-lottery7_1768289136854b6aede.webp"
      alt="酒吧大屏互动抽奖名单导入"
      class="example-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-lottery4_1768288657288bdee3b.webp"
      alt="酒吧大屏互动名单抽奖"
      class="example-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-lottery5_176828865728844d217.webp"
      alt="酒吧大屏互动数字抽奖"
      class="example-image"
    />
    <h4 class="content-text">（3）许愿树抽奖</h4>
    <h4 class="content-text">
      用户扫码签到后需要先编辑发送文字愿望，然后随机走许愿池中抽取幸运用户获奖。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-lottery6_176828865728833e347.webp"
      alt="酒吧大屏互动许愿树抽奖功能"
      class="example-image"
    />
  </div>
</template>

<script>
export default {
  name: 'Lottery',
};
</script>

<style lang="less" scoped>
.lottery {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.center {
  text-align: center;
  margin-top: 0;
}
</style>
